import { Context } from '@nuxt/types';
import { CookieOption } from '@axten/cookies-controller/dist/types/src/cookies-controller.vue';
import { machinationsCookiePreferences } from './../../domain/constants/CookiesConst';
import { CookiesControllerState } from '~/domain/interfaces/CookiesStateTypes';
export default {
  initCookies: (state: CookiesControllerState, params: {localStorage: Storage, context: Context}) => {
    if(params.localStorage) {
      const cookiesPref = params.localStorage.getItem('cookiesPref');
      const cookiesState: CookiesControllerState | null = JSON.parse(cookiesPref || "null");
      const now = Date.now();

      if (!cookiesState?.expiresAt || now > cookiesState?.expiresAt) {
        // load default
        params.localStorage.removeItem('cookiesPref');
        state.isBannerVisible = true;
        state.cookies = machinationsCookiePreferences(params.context.$config.cookiesEnvConfig);
      } else {
        state.isBannerVisible = cookiesState.isBannerVisible;
        if (cookiesState.cookies) {
          state.cookies = cookiesState.cookies;
        } else {
          state.cookies = machinationsCookiePreferences(params.context.$config.cookiesEnvConfig);
        }
      }
    }
  },
  setCookies: (state: CookiesControllerState, 
  params: {localStorage: Storage, cookiesData: {[key: string]: CookieOption[]}}) => {
    state.cookies = params.cookiesData
    state.isBannerVisible = false
    if(params.localStorage) {
      const expires = new Date();
      expires.setMonth(expires.getMonth() + 6);
      params.localStorage.setItem('cookiesPref', JSON.stringify({...state, expiresAt: expires.getTime()}));
    }
  },
  setBannerVisibility: (state: CookiesControllerState,
    params: {visible: boolean, localStorage: Storage}) => {
      state.isBannerVisible = params.visible
      if(params.localStorage) {
        const expires = new Date();
        expires.setMonth(expires.getMonth() + 6);
        params.localStorage.setItem('cookiesPref', JSON.stringify({...state, expiresAt: expires.getTime()}))
      }
    }
}